import { Group } from '@/components/_common';
import { useBankSlipPublicPdf } from '@/core/domain/financial/Boletos/Boletos.hooks';
import { useReportActions } from '@/hooks/useReportActions';
import useUrlParams from '@/hooks/useUrlParams';
import LayoutPublicHeader from '@/layouts/PublicLayout/components/PublicHeader';
import { Button, Card, Result, Spin } from 'antd';
import moment from 'moment';
import { useEffect } from 'react';
import { FaRegFilePdf } from 'react-icons/fa';

export default function BankSlipReportPublic() {
  const { token } = useUrlParams<{ token: string }>().searchParams;
  const bankSlipPublicPdf = useBankSlipPublicPdf();

  const { handlePdf } = useReportActions({
    fileName: `boleto-${moment().format('DDMMYYYYHHmmss')}`,
    generate: async () => {
      if (!token) return;

      return await bankSlipPublicPdf.mutateAsync(token);
    },
  });

  useEffect(() => {
    if (token) handlePdf();
  }, [token]);

  return (
    <>
      <LayoutPublicHeader />

      {bankSlipPublicPdf.isLoading && (
        <Group
          position="center"
          align="center"
          gap={16}
          style={{
            width: '100%',
            height: '100vh',
            flexDirection: 'column',
          }}
        >
          <Spin size="large" />
          <h4>Gerando boleto, aguarde um instante...</h4>
        </Group>
      )}

      {!bankSlipPublicPdf.isLoading && !!bankSlipPublicPdf.data && (
        <Group
          position="center"
          align="center"
          style={{
            width: '100%',
            height: '100vh',
            padding: 24,
            background:
              'linear-gradient(180deg, rgba(245,247,250,1) 0%, rgba(255,255,255,1) 100%)',
          }}
        >
          <Card
            style={{
              maxWidth: 420,
              textAlign: 'center',
              padding: 24,
              borderRadius: 16,
              boxShadow:
                '0 4px 12px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.08)',
            }}
          >
            <Group position="center" gap={12} style={{ marginBottom: 16 }}>
              <FaRegFilePdf size={28} color="#1677ff" />
              <h2 style={{ margin: 0 }}>Boleto gerado com sucesso</h2>
            </Group>

            <p style={{ margin: '8px 0', color: '#555' }}>
              O boleto foi gerado e o download deve iniciar automaticamente.
            </p>
            <p style={{ margin: '8px 0', color: '#555' }}>
              Caso o download não tenha começado, clique abaixo para tentar
              novamente.
            </p>

            <Button
              type="primary"
              size="large"
              style={{
                marginTop: 16,
                borderRadius: 8,
                fontWeight: 500,
                paddingInline: 24,
              }}
              onClick={handlePdf}
            >
              Baixar boleto novamente
            </Button>

            <p
              style={{
                fontSize: 13,
                color: '#888',
                marginTop: 16,
              }}
            >
              Verifique a pasta de downloads do seu navegador.
            </p>
          </Card>
        </Group>
      )}

      {!bankSlipPublicPdf.isLoading && bankSlipPublicPdf.isError && (
        <Group
          position="center"
          align="center"
          style={{ width: '100%', height: '100vh' }}
        >
          <Result
            status="error"
            title="Não foi possível gerar o boleto"
            subTitle="O link pode estar expirado ou o documento não está mais disponível."
            extra={[
              <Button key="retry" type="primary" onClick={handlePdf}>
                Tentar novamente
              </Button>,
            ]}
          />
        </Group>
      )}

      {!token && (
        <Group
          position="center"
          align="center"
          style={{
            width: '100%',
            height: '100vh',
            background:
              'linear-gradient(180deg, rgba(245,247,250,1) 0%, rgba(255,255,255,1) 100%)',
          }}
        >
          <Result
            status="warning"
            title="Boleto não encontrado"
            subTitle="O link informado é inválido ou não contém o token necessário."
          />
        </Group>
      )}
    </>
  );
}
